export default __webpack_public_path__ + "static/media/R.e5116180.svg";